import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSFormLayoutCheckboxGroupName = 'DSFormlayoutcheckboxgroup';

export const FORM_LAYOUT_CHECKBOX_GROUP_SLOTS = {
  ROOT: 'root',
} as const;

export const FORM_LAYOUT_CHECKBOX_GROUP_DATA_TESTID = slotObjectToDataTestIds(
  DSFormLayoutCheckboxGroupName,
  FORM_LAYOUT_CHECKBOX_GROUP_SLOTS,
);
